import { Box, ListItem, ListItemText, useTheme } from "@mui/material";
import * as React from "react";

import { ClearFieldButton } from "@/Actions/components/action/ClearFieldButton";
import { EditFieldButton } from "@/shared/components";
import { UISimpleCondition } from "@/shared/components/filters";
import { UpdateTriggerRequest } from "@/shared/domain/actions/TriggerRecord";
import { Condition, ConditionGroup, ConditionsOperator } from "@/types";

import { TriggerCondition } from "../TriggerCondition";

import { conditionsToUiSimpleConditions } from "./helpers";

interface EditableTriggerConditionProps {
  onChange: (updates: UpdateTriggerRequest) => void;
  value: Condition | undefined;
  setErrorText: (arg: string) => void;
}

export const EditableTriggerCondition: React.FC<
  EditableTriggerConditionProps
> = ({ onChange, value, setErrorText }) => {
  const theme = useTheme();

  const [showEditableIcon, setShowEditableIcon] = React.useState(false);
  const [editable, setEditable] = React.useState(false);

  const [operator, setOperator] = React.useState<ConditionsOperator>("AND");
  const [conditions, setConditions] = React.useState<UISimpleCondition[]>([]);

  React.useEffect(() => {
    if (value && "operator" in value) {
      setOperator(value.operator);
    }
    setConditions(conditionsToUiSimpleConditions(value));
  }, [value]);

  let group: ConditionGroup | null;
  if (conditions.length === 0) {
    group = null;
  } else {
    group = {
      conditions: conditions,
      operator: operator,
    };
  }

  const updateRecord = (reset?: boolean) => {
    setErrorText("");
    const condition = reset ? null : group;

    onChange({
      condition: condition,
    });
  };

  const onClick = () => {
    if (editable) {
      updateRecord();
    }
    setEditable(!editable);
  };

  return (
    <ListItem
      onMouseOver={() => {
        setShowEditableIcon(true);
      }}
      onMouseLeave={() => {
        setShowEditableIcon(false);
      }}
    >
      <ListItemText
        primaryTypographyProps={{
          component: "span",
        }}
        sx={{
          mt: theme.spacing(0.5),
        }}
        primary={
          <>
            <span>Conditions</span>
            <EditFieldButton
              editable={editable}
              showEditableIcon={showEditableIcon}
              onClick={() => {
                void onClick();
              }}
            />

            {conditions && (
              <ClearFieldButton
                showIcon={showEditableIcon}
                onClick={() => {
                  updateRecord(true);
                  setConditions([]);
                  setOperator("AND");
                }}
              />
            )}
          </>
        }
        secondaryTypographyProps={{
          component: "span",
        }}
        secondary={
          <>
            <Box>
              {conditions.length === 0 && "None"}
              <Box>
                <TriggerCondition
                  conditions={conditions}
                  setConditions={setConditions}
                  operator={operator}
                  setOperator={setOperator}
                  editable={editable}
                />
              </Box>
            </Box>
          </>
        }
      />
    </ListItem>
  );
};
